import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { addUserCommodity, getAllCommodityApi } from '@data'
import { UserCommodity } from '@data/model'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, MultiSelect } from '@baseV2'

import { InputsWrapper } from '../styles'

const AddCommodity = ({ activeCommodity, updateCommodity, organisationId, commodities = null }) => {
	const dispatch = useDispatch()
	const [commodityList, setCommodityList] = useState([])
	const [selected, setSelected] = useState(commodities || (activeCommodity ? [activeCommodity] : []))

	useEffect(() => {
		getAllCommodityApi()
			.then((res) => setCommodityList(res ?? []))
			.catch((err) => console.log(err))
	}, [])

	const addCommodityHandler = () => {
		if (!selected.length) return
		const list = selected.map((value) => new UserCommodity(value).hasCommodity())
		dispatch(showLoader(true))
		addUserCommodity(list, organisationId)
			.then(() => {
				dispatch(showToast(true, strings('add_commodity_success'), { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				updateCommodity?.()
			})
			.catch((err) => dispatch(showToast(true, err, { type: TOAST_TYPE.ERROR })))
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<MultiSelect
						id='commodity-units-v2'
						label={strings('select', 'commodity')}
						placeholder={strings('select', 'commodity')}
						data={commodityList}
						value={selected}
						displayKey='commodity_name'
						primaryKey='commodity_name'
						onChange={setSelected}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={!selected.length} onClick={addCommodityHandler}>
					{strings('add', 'commodity')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AddCommodity
